import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `On My Painting by Max Beckmann | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Compiled and edited by George Scrivani for Hanuman Books in 1988, On My Painting collects six texts from the pioneering German artist Max Beckmann, who fled Nazi Germany after his paintings—increasingly moody and reflective of the existential terror of the time—were labeled "degenerate".`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-One/MaxBeckman_Mockup1.webp', '../../Series-One/MaxBeckman_Mockup2.webp', '../../Series-One/MaxBeckman_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>On My Painting</h1>
            <div className='productAuthor'>Max Beckmann</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378005'} />
            <div className='productPrice'>$12.99 USD</div>
          </div>
          <div className='productExcerpt'>
            One of my problems is to find the Self, which has only one form and is immortal­—to find it in animals and men, in the heaven and in the hell which together form the world in which we live.

          </div>

          <div className='productDescription'>Compiled and edited by George Scrivani for Hanuman Books in 1988, <em>On My Painting</em> collects six texts from the pioneering German artist Max Beckmann, who fled Nazi Germany after his paintings—increasingly moody and reflective of the existential terror of the time—were labeled "degenerate". In addition to the titular essay, this volume contains short pieces "Creative Credo" and "The New Program", extracts from his <em>Diaries</em>, three "Letters to a Woman Painter", and the text of a speech given to the philosophy faculty at Washington University in St. Louis, shortly before his death in 1950.
          </div>
          <div className='productDescription'>
            <p><strong>Max Beckmann</strong> (1884-1950) was a German artist whose body of work includes painting and sculpture. A rising star during the Weimar era, Beckmann left Germany following the ascent of Adolf Hitler, living in self-imposed exile in Amsterdam before finally being granted a teaching position in the United States in 1947. He died of a heart attack in 1950. Though he eschewed the label of "Expressionism", he is often associated with the movement, and was heavily influential on the American offshoots that followed.</p>
          </div>
          <div className='productMetadata'>
            <div>Series I</div>
            <div>Autumn 2023</div>
            <div>ISBN 979-8-9893780-0-5</div>
            <div>4.125 x 2.75 x 0.54 inches</div>
            <div>80 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}